import { render } from "./ProspectsRedirectionManager.vue?vue&type=template&id=1506c940&scoped=true"
import script from "./ProspectsRedirectionManager.vue?vue&type=script&lang=js"
export * from "./ProspectsRedirectionManager.vue?vue&type=script&lang=js"

import "./ProspectsRedirectionManager.vue?vue&type=style&index=0&id=1506c940&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1506c940"]])

export default __exports__